var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReceipt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6665 3.99992V5.61325C14.6665 6.66659 13.9998 7.33325 12.9465 7.33325H10.6665V2.67325C10.6665 1.93325 11.2732 1.33325 12.0132 1.33325C12.7398 1.33992 13.4065 1.63325 13.8865 2.11325C14.3665 2.59992 14.6665 3.26659 14.6665 3.99992Z",
    fill: "#3694FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.3335 4.66659V13.9999C1.3335 14.5533 1.96017 14.8666 2.40017 14.5333L3.54016 13.6799C3.80683 13.4799 4.18017 13.5066 4.42017 13.7466L5.52682 14.8599C5.78683 15.1199 6.2135 15.1199 6.4735 14.8599L7.5935 13.7399C7.82683 13.5066 8.20016 13.4799 8.46016 13.6799L9.60016 14.5333C10.0402 14.8599 10.6668 14.5466 10.6668 13.9999V2.66659C10.6668 1.93325 11.2668 1.33325 12.0002 1.33325H4.66683H4.00016C2.00016 1.33325 1.3335 2.52659 1.3335 3.99992V4.66659Z",
    fill: "#C6E1FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6.5H4C3.72667 6.5 3.5 6.27333 3.5 6C3.5 5.72667 3.72667 5.5 4 5.5H8C8.27333 5.5 8.5 5.72667 8.5 6C8.5 6.27333 8.27333 6.5 8 6.5Z",
    fill: "#3694FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9.16675H4.5C4.22667 9.16675 4 8.94008 4 8.66675C4 8.39341 4.22667 8.16675 4.5 8.16675H7.5C7.77333 8.16675 8 8.39341 8 8.66675C8 8.94008 7.77333 9.16675 7.5 9.16675Z",
    fill: "#3694FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceipt);
export default __webpack_public_path__ + "static/media/receipt.70873b03b5013a82c701bbd5b23f670a.svg";
export { ForwardRef as ReactComponent };